import { useMutation } from "react-query";

import { buildFormDataPayload } from "../../helpers/api";
import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  ExpenseClaimChargingType,
  ExpenseClaimType,
} from "../../types/ExpenseClaim";

type CreateExpenseClaimPayload = {
  claimType: ExpenseClaimType;
  ocrRequestId?: string;
  transactionDate: string;
  description: string;
  incGst: number;
  exGst: number | null;
  vendor: string | null;
  taxInvoice: File | null;
  chargingType: ExpenseClaimChargingType | null;
  currentOdometer: number | null;
  chargingReport: File | null;
};

export const createExpenseClaim = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: CreateExpenseClaimPayload): Promise<string> => {
      return fetchWithAuth<string>("createExpenseClaim", dossierId, {
        requestOptions: {
          method: "post",
          body: buildFormDataPayload(payload, ["taxInvoice", "chargingReport"]),
          excludeContentTypeHeader: true,
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([["awaitingExpenseClaims", dossierId]]),
  });
};
